export default __webpack_public_path__ + "static/media/Ballroll_00333.1d8e0872.png";